export const DEFAULT_FETCH_ITEMS_COUNT = 48;

export const FETCH_ALL_ITEMS = 10000;

export const MEASURE_UNITS = ["кг.", "бр.", "гр.", "л.", "мл.", "мг."];

export const ORDER_STATUSES = {
    INITIAL: "INITIAL",
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
    DELIVERED: "DELIVERED"
};


export const PRODUCT_TYPE = {
    CUSTOM: "custom"
};

export const RATING_CRITERIA = {
    DELIVERY: "QUICK_DELIVERY",
    QUALITY: "PRODUCT_QUALITY",
    QUANTITY: "CORRECT_QUANTITY",
};

export const PRODUCT_STATUS = {
    AVAILABLE: "AVAILABLE",
    NOT_AVAILABLE: "NOT_AVAILABLE",
    ON_REQUEST: "ON_REQUEST"
};

export const ROUTES = {
    HOME: "/",
    ADMIN: {
        ADMIN_HOME: "/admin",
        ADMIN_ORDERS: "/admin/orders",
        ADMIN_ORDER: {
            ROUTE: "/admin/order/:id",
            LINK: "/admin/order"
        },
        GLOBAL_PRODUCTS: "/admin/globalproducts",
        NEW_GLOBAL_PRODUCT: "/admin/globalproduct/:from",
        NEW_GLOBAL_PRODUCT_LINK: "/admin/globalproduct",
        IMPORT: "/admin/import",
        IMPORT_MATCH_2:"/admin/import/match",
        MATCH_BY_NAME: "/admin/import/matchbyname",
        FINISH_IMPORT: "/admin/import/finish",
        USERS_LIST: "/admin/users",
        NEW_EDIT_USER_ROUTE: "/admin/user/:action",
        NEW_EDIT_USER_LINK: "/admin/user",
        PROFILE: "/admin/profile",
        LIST_CLIENTS_VENDORS: "/admin/clients/vendors",
        LIST_CLIENTS_CUSTOMERS: "/admin/clients/customers",
        NEW_EDIT_VENDOR_ROUTE: "/admin/vendor",
        NEW_EDIT_CUSTOMER_ROUTE: "/admin/customer",
        NEW_EDIT_POS: "/admin/pointofsale"
    },
    CUSTOMER: {
        CUSTOMER_HOME: "/customer",
        VENDOR_PAGE: "/customer/vendorpage",
        SHOPPING_CART: "/customer/shoppingcart",
        ORDER_WITH_STATUS_INITIAL_VIEW: {
            ROUTE: "/customer/shoppingcart/order/:id",
            LINK: "/customer/shoppingcart/order"
        },
        ALL_ORDERS_PAGE: "/customer/orders",
        SENT_ORDER_VIEW: {
            ROUTE: "/customer/order/:id",
            LINK: "/customer/order"
        },
        NOTIFICATIONS_PAGE: "/customer/notifications",
        PROFILE: "/customer/profile"
    },
    VENDOR: {
        VENDOR_HOME:"/vendor",
        VENDOR_ORDERS: "/vendor/orders",
        VENDOR_ORDER: {
            ROUTE: "/vendor/order/:id",
            LINK: "/vendor/order"
        },
        VENDOR_PRODUCTS: "/vendor/products",
        VENDOR_IMPORT: "/vendor/import",
        PROFILE: "/vendor/profile"
    }
};

export const USER_ROLES = {
    ADMIN: "ADMIN",
    CUSTOMER: "CUSTOMER",
    VENDOR: "VENDOR"
};

export const PASSWORD_MINIMAL_LENGTH = 8;

export const CATEGORY_TYPES = {
    PRODUCT: "PRODUCT",
    COMPANY: "COMPANY"
};

export const NET_WEIGHT_UNITS = ["няма", "кг.","гр.","мг.", "л.", "мл."];

export const CORS_PROXY = "http://localhost:3003/";